import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactFloat from "@/components/ContactFloat";
import IndustrySolutionSections from "@/components/IndustrySolutionSections";
import KnowledgeBaseMindMap from "@/components/KnowledgeBaseMindMap";

export default function HomeStorageSolutions() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("homeStorage.title")}</title>
        <meta name="keywords" content={t("homeStorage.keywords")} />
        <meta name="description" content={t("homeStorage.description")} />
      </Helmet>
      <ContactFloat />

      <section
        className="w-full bg-[#1a2d42]"
        data-aos="fade-right"
        data-aos-offset="100"
        data-aos-duration="500"
      >
        <div className="relative isolate h-[400px] w-full overflow-hidden">
          <img
            src="/solutions/home-storage-banner.jpeg"
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-[50%_13%]"
          />
          <div className="absolute inset-0 bg-linear-to-r from-[#0f1f30]/92 via-[#0f1f30]/72 to-transparent" />
          <div className="relative z-10 grid h-full w-1200 place-items-center px-4 text-center">
            <div>
              <h2
                className="text-[30px] leading-snug font-bold text-white"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("homeStorage.banner.title")}
              </h2>
              <span
                className="mx-auto mt-3 block h-[4px] w-[50px] bg-white"
                data-aos="zoom-in"
                data-aos-delay="300"
              />
              <p
                className="mt-5 text-base text-white/90 md:text-lg"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("homeStorage.banner.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <KnowledgeBaseMindMap
        rootLabel={t("homeStorage.knowledgeBase.rootLabel")}
        rootColor="#0ea5e9"
        treeTranslationKey="homeStorage.knowledgeBase.tree"
        i18nPrefix="homeStorage.knowledgeBase"
      />

      <IndustrySolutionSections
        i18nPrefix="homeStorage"
        images={{
          painPoints: "/solutions/home-storage-pain.jpeg",
          solutions: "/solutions/home-storage-solutions.jpeg",
          cta: "/solutions/home-storage-cta.jpeg",
        }}
        imagesPos={{
          painPoints: "55% 25%",
          solutions: "73% 24%",
          cta: "50% 12%",
        }}
      />
    </>
  );
}
